import axios from "axios";
import { apiServicesUrl } from "./baseUrl";
import { userAccessToken } from "../helpers";

export const fetchEligibilityLogs = (filter) => {
  const {
    page,
    per_page,
    search_term,
    start_date,
    end_date,
    account_id,
    location_id,
    order_by
  } = filter;

  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let startDateParam = start_date ? `&start_date=${start_date}` : "";
  let endDateParam = end_date ? `&end_date=${end_date}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

  return axios.get(
    `${apiServicesUrl}/waiting_room/stedi-logs?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${startDateParam}${endDateParam}${orderBy}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const fetchPrevisitHistory = async (
  account_id,
  location_id,
  patient_id = null,
  dos = null,
) => {
  let previsitDos = dos ? `&dos=${dos}` : "";
  try {
    const response = await axios.get(
      `${apiServicesUrl}/waiting_room/previsit-history?account_id=${account_id}&location_id=${location_id}&patient_id=${patient_id}${previsitDos}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const fetchSingleClinicalData = async (
  account_id,
  location_id,
  clinical_id = null,
) => {
  try {
    const response = await axios.get(
      `${apiServicesUrl}/clinical-note/single?account_id=${account_id}&location_id=${location_id}&clinical_note_id=${clinical_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const uploadClinicalNotes = async (data) => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    const response = await axios.post(
      `${apiServicesUrl}/clinical-note/bulk-upload`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const saveClinicalTranscriptionText = async (
  account_id,
  location_id,
  id,
  voice_transcribe,
  record_times
) => {
  try {

    let data = {
      account_id: account_id,
      location_id: location_id,
      id: id,
      voice_transcribe: voice_transcribe,
      record_times: record_times
    };
    return axios.put(
      `${apiServicesUrl}/clinical-note/transcribe-update`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );


  } catch (error) {}
};

export const resetClinicalNote = async (data) => {
  try {
    const response = await axios.put(`${apiServicesUrl}/clinical-note/reset`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const MarkCompleteClinicalNote = async (data) => {
  try {
    const response = await axios.put(`${apiServicesUrl}/clinical-note/update-status`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const addClinicalPatients = async (formData) => {
  try {
    const response = await axios.post(`${apiServicesUrl}/clinical-note/create`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateClinicalPostVisitNote = (data) => {
  try {
    const response = axios.put(`${apiServicesUrl}/clinical-note/postvisit-update`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteClinicalNote = async (id, account_id, location_id) => {
  try {
    const response = await axios.delete(
      `${apiServicesUrl}/clinical-note/delete?account_id=${account_id}&location_id=${location_id}&clinical_note_id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteBulkClinicalNoteData = async (deleteData) => {
  try {
    const response = await axios.delete(`${apiServicesUrl}/clinical-note/bulk-delete`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
      data: deleteData,
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
